<template>
    <div ref="fristhome">
<!--        <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--            <el-breadcrumb-item>系统单险种多车</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
        <el-card class="box-card">
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    autocomplete="on"
                    size="mini">
            <dl class="sysDl" >
                <dt >
                    <h5 >其他渠道保险～建档</h5>
                    <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;">
                        <el-form-item>
                            <el-button   @click.native="addData">单车多险种</el-button>
                        </el-form-item>
<!--                        <el-form-item>-->
<!--                            <el-button   @click.native="addByProduct">单险种多车</el-button>-->
<!--                        </el-form-item>-->
                    </p>
                </dt>
                <dd class="sysDd" >
                    <h5  >系统内保险</h5>
                    <p class="sysP" >
<!--                        <el-form-item>-->
<!--                            <el-button   @click.native="addSysCar">系统单车多险种</el-button>-->
<!--                        </el-form-item>-->
                        <el-form-item>
                            <el-button  type="primary" @click.native="addSysProduct">系统单险种多车</el-button>
                        </el-form-item>
                    </p>
                    <div class="sysdiv">
                      <p style="font-weight: bold"> 订单提交时间：</p>
                      <p style="font-size: 15px;margin-top: 10px">工作日8-16点</p>
                    </div>
                </dd>
              <dd style="margin-left: 50px;width: 30%;">
                <p style="display:inline-flex;flex-direction: row;align-items: center;padding: 10px; margin-right: 20px">保险顾问：{{link_name}} {{link_tel}}</p>
                <p style="display:inline-flex;flex-direction: row;align-items: center;padding: 10px;">监督服务：{{contact_name}} {{contact_mobile}}</p>
              </dd>
            </dl>
            </el-form>

                <el-tabs v-model="activeName" @tab-click="handleClick">

                    <el-tab-pane label=" ★ 联合团单" name="second">
                      <union-product-order></union-product-order>

                    </el-tab-pane>
                </el-tabs>


        </el-card>
        <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo"/>
        <eProduct :productVisibleProp.sync="isShowProduct" v-on:eventProduct="chooseProductInfo"/>
        <!---->
        <el-dialog width="70%" title="车辆列表" :visible.sync="productVisible" @close="closeProduct">
            <el-form size="mini" :model="searchForm1" ref="searchForm1" :inline="true">
                <el-form-item label="关键字名称" prop="keywords">
                    <el-input   v-model="searchForm1.keywords" placeholder="请输入车牌号码/所有人"/>
                </el-form-item>
                <el-form-item prop="name">
                    <el-button type="primary" @click="searchCar">查询</el-button>
                </el-form-item>
                <div>
                    <el-table :data="productList" border  size="mini" style="width: 100%;" stripe height="260">
                        <el-table-column label="选择" align="center" width="55">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.$index" v-model="scope.row.checked" @change.native="getCurrentRow(scope.row,scope.$index)">&nbsp;</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="120"
                                prop="plate_number"
                                :show-overflow-tooltip='true'
                                label="车辆号码">
                        </el-table-column>
                        <el-table-column
                            width="120"
                            prop="allPerson"
                            :show-overflow-tooltip='true'
                            label="所属人">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                prop="vehicle_type"
                                :show-overflow-tooltip='true'
                                label="车辆类型">
                        </el-table-column>
                        <el-table-column
                                prop="vin"
                                width="150"
                                :show-overflow-tooltip='true'
                                label="车架号">
                        </el-table-column>
                        <el-table-column
                                prop="model"
                                width="180"
                                :show-overflow-tooltip='true'
                                label="品牌型号">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                prop="use_character"
                                label="使用性质">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                prop="out_to_out"
                                label="外廓尺寸">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                label="挂车车牌号">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                label="挂车类型">
                        </el-table-column>
                    </el-table>
                    <div class="block" style="margin-top:10px">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNum"
                                :page-sizes="[10, 20, 30, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
                <el-row>
                    <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                        <el-button size="mini" @click="productVisible = false">取消</el-button>
                        <el-button  size="mini" type="primary" @click="okCar">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!---->
        <!---->
        <el-dialog width="50%" :title="ProTitle" :visible.sync="noticeVisible" :close-on-click-modal="false" lock-scroll :close-on-press-escape="false"  :show-close="false">
            <div>
              {{cpys}}
            </div>
            <el-row>
                <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                    <el-button  size="mini" type="primary" @click="okRead">已阅读</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <!---->
      <!--图片放大组件-->
      <bigImg :visible.sync="isShowImg" :url="img" />
    </div>
</template>
<script>
    import eCar from "../common/eCar";
    import eProduct from "../common/eProduct";
    import moment from 'moment'     //日期时间转换
    import Watermark from "../../utils/waterMark";
    import bigImg from "../common/bigImg";
    import UnionProductOrder from "../common/unionProductOrder.vue";
    export default {
        name:'eInsurance',
        props:['carVisibleProp','productVisibleProp'],
        components: {
          UnionProductOrder,
            eCar,
            eProduct,
            bigImg
        },
        data(){
            return {
                productPage:true,
                isUsed:false,
                pickerOptions1:{
                    disabledDate(time) {
                        return time.getTime() <= Date.now() ;
                    }
                },
                carGroups:[],
                noticeVisible:false,
                isRead:false,
                currIndex:'',
                currProductIndex:'',
                currM:'',
                pageSize:10,
                pageNum:1,
                total:0,
                pageSizeP:10,
                pageNumP:1,
                totalP:0,
                shopList:'',
                applicantLoading:false,
                applicantList:[],
                applicantStates:[],

                cpys:'',
              ProTitle:'',
                corp:'',
                corpLoading:'',
                corpList:[],
                corpStates:[],

                isShowCar:false,
                isShowProduct:false,

                productList:[],
                productMList:[],
                productVisible:false,
                index:0,
                pIndex:-1,
                carIndex:0,
                productId:[],
                options: [],
                carList: [],
                loading: false,
                states: [],

                searchForm:{
                    keywords:"",
                    corp_id:''
                },
                searchForm1:{
                    keywords:"",
                },
                addForm:{
                    type:2,
                    product_md_name:'',
                    product_md_id:'',
                    contact_name:'',
                    contact_mobile:'',
                    real_price:'',
                    price:'',
                    sell_price:'',
                    old_sell_price:'',
                    owner_id:'',

                    owner_name:'',
                    owner_idcard:'',
                    owner_mobile:'',

                    shop_id:'',
                    toubao_name:'',
                    toubao_idcard:'',
                    toubao_mobile:'',

                    corp_name:"",
                    plate_number:'',
                    car_id:'',
                    applicant:'',
                    applicant_tel:'',
                    applicant_idcard:'',
                    insured:"",
                    insured_idcard:"",
                    insured_tel:"",
                    link_name:'',
                    link_tel:'',
                    remark:'',

                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                },
                rules: {
                    applicant: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
                    insured: [{ required: true, message: '请输入被投保人', trigger: 'blur' }],
                },
                searchRules: {
                    name: [
                        { required: true, message: "请输入公司名称", trigger: "blur" },
                    ],
                },
                title:'保单新增',
                car_number:'',
                fileList:[],
                activeName: 'second',
                insurance_date:'',
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                list: [],
                link_name:'',
                link_tel:'',
                contact_name:'',
                contact_mobile:'',
                isShowImg:false,
                img:'',
                reneInfo:[]
            }
        },
        mounted() {
            this.carList = this.states.map(item => {
                return { value: `${item}`, label: `${item}` };
            });
            this.getCarList();
            this.getProductMList();
        },
      created() {
        //this.outoRene(this.$route.query.reneInfo);

        //console.log("reneInfo:",this.$route.query.reneInfo);console.log("reneInfo:",this.$route.query.reneInfo);
        this.shopList=JSON.parse(sessionStorage.getItem('shopList'));
        this.searchForm.shop_id  = this.shopList[0] ? this.shopList[0]['shop_id']:'';
        this.link_name = sessionStorage.getItem('link_name');
        this.link_tel = sessionStorage.getItem('link_tel');
        this.contact_name = sessionStorage.getItem('contact_name');
        this.contact_mobile = sessionStorage.getItem('contact_mobile');
        this.corpRemoteMethod();
        let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
        this.$nextTick(() => { //要加载完才能获取$refs
          Watermark.set(str,this.$refs.fristhome)
        })
      },
      methods:{

        openWin(url) {
          //console.log('img:',url)
          this.isShowImg = true;
          this.img = url;
         // var name;                           //网页名称，可为空;
         // var iWidth = 500;                         //弹出窗口的宽度;
         // var iHeight = 570;                        //弹出窗口的高度;
         // var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
         // var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
         // window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
        },
            searchCar(){
                this.getCarList();
            },
            beforeAvatarUpload(){

            },
            handleAvatarSuccess(){
                    ////console.log('lu------',item.raw)
                    this.imageUrl = URL.createObjectURL(item.raw);
                    let file = item.raw;
                    let _this=this;

            },
            searchClick(val){

                this.currIndex='';
                this.searchForm.keywords=val;
                this.productMList=[];
                this.getProductMList();
            },
          searchClick2(){
              this.searchForm = {
                  keywords:""
              };
              this.getProductMList();
          },
            searchClick1(){
                this.productMList=[];
                this.getProductMList();

            },
            okProduct(row,idx){
                this.addForm.product_md_id=row.id;
                this.addForm.product_id=row.product_id;
                this.addForm.contact_name=row.contact_name;
                this.addForm.contact_mobile=row.contact_mobile;

               let tmp= this.productMList[idx];

                this.productMList=[];
                this.productMList.push(tmp)

                this.isUsed=true;
                this.productPage = false;
            },
            cancelChooseProduct(row,idx){
                this.currIndex='';
                this.productMList=[];
                this.getProductMList();
                this.isUsed=false;
                this.productPage = true;
                location.reload()
            },
            okRead(){
                this.noticeVisible=false;
                this.isRead=true;
            },
            readNotice(row){
                this.cpys = row.cpys
                this.ProTitle = '投保告知'
                this.noticeVisible=true
            },
            readNoticeTwo(row){
              this.cpys = row.desc
              this.ProTitle = '承保要求'
              this.noticeVisible=true
            },
            openNoticeDialog(row){
                this.noticeVisible=true;
            },
            searchProductMd(){
                this.productMList=[];
                this.getProductMList();
            },
            handleSizeChange(newSize){
                this.pageSize = newSize
                this.getCarList()
            },
            handleCurrentChange(newPage){
                this.pageNum = newPage
                this.getCarList();
            },
          handleSizeChangeP(newSize){
            this.pageSizeP = newSize
            this.getProductMList()
          },
          handleCurrentChangeP(newPage){
            this.pageNumP = newPage
            this.getProductMList();
          },
            // 新增
            addData() {
                this.$router.push('/insuranceAdd');
            },
            addByProduct(){
                this.$router.push('/insuranceAddByProduct');
            },
            addSysProduct(){
                this.$router.push('/insuranceSysProduct');
            },
            addSysCar(){
                this.$router.push('/insuranceSysCar');
            },
            getCurrentRow(row,index){
              //console.log('row:value',row)
              if(row.checked)
              {
                if(this.list.length>0){
                    for (var i=0;i<this.list.length;i++){
                        if(this.list[i].plate_number==row.plate_number){
                            this.$message.error("车辆不能重复添加");
                            return;
                        }
                    }
                }
                this.productList[index].checked = true
                this.productList[index].carIndex = this.carIndex
                let item = {
                    plate_number:row.plate_number,
                    allPerson:row.allPerson,
                    credit_code:row.shop? row.shop.credit_code:'',
                    vehicle_type:row.vehicle_type,
                    vin:row.vin,
                    out_to_out:row.out_to_out,
                    model:row.model,
                    car_id:row.id,
                    fee:0,
                    effective_date:this.getNowTime(),
                    start_time:'',
                    end_time:'',
                    fruitSort: null,
                    firstNum: null,
                    isEgdit: false,
                    shop_id:row.shop_id,
                    contact_name:'',
                    contact_mobile:'',
                    file_url:'',
                    owner_id:row.owner_id,
                    fileList:[],
                  real_price:this.addForm.real_price,
                  price:this.addForm.price,
                  sell_price:this.addForm.old_sell_price,
                }
                this.list.push(item)
                   this.carGroups=[];
                    let json= this.arrayGroupBy(this.list,'allPerson');
                     //console.log('arrayGroupBy-----',json)
                    let tmpList=[];
                    let {keys,values,entries} = Object
                    for (const [key,val] of entries(json)) {
                        let reg = new RegExp('"',"g");
                        let newKey = key.replace(reg, "");
                        tmpList.push({
                            type:newKey,
                            data:val
                        })
                    }
                    //console.log('arrayGroupBy_rs-----',tmpList)
                    if(tmpList.length>0){
                        for (var i=0;i<tmpList.length;i++){
                            let itm={
                                allPerson:tmpList[i].type,
                                credit_code:tmpList[i].data[0].credit_code,
                                num:tmpList[i].data.length
                            }
                            this.carGroups.push(itm);
                        }
                    }
              }else{
                this.productList[index].checked = false
                this.list.forEach((lItem, Lindex)=>{
                   if(lItem.plate_number == this.productList[index].plate_number)
                   {
                     this.$delete(this.list, Lindex);
                   }
                })
              }
              //console.log('cc',this.list)
              //console.log('productList',this.productList)

            },
            getCarList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    page:this.pageNum,
                    pageSize:this.pageSize
                }
                if(this.searchForm1.keywords){
                    param.queryParams=this.searchForm1.keywords;
                }
                this.$axios.carFilesList(param).then(res=>{
                    if(res.code == 200){
                        this.productList = res.data.data
                        for(let key in this.productList){
                          this.$set(this.productList[key],'checked',false)
                        }
                        this.total = res.data.total
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            getProductList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.insuranceProdcutList(param).then(res=>{
                    if(res.code == 200){
                        this.productList = res.data.data
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },

            applicantRemoteMethod(query){
                if (query !== '') {
                    this.applicantLoading = true;
                    let param={
                        queryParams:query,
                        operator_id:sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                    }

                    //console.log('param------',param)

                    this.$axios.shopList(param).then(res=>{
                        if(res.code == 200){
                            this.applicantStates = res.data.data;
                        }else{
                          this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        //console.log(error);
                    })
                    setTimeout(() => {
                        this.applicantLoading = false;
                        this.applicantList = this.applicantSet.filter(item => { // 这里的this.list，换为this.applicantSet
                            return item.name;
                        });
                    }, 1000);
                } else {
                    this.applicantList = [];
                }
            },
            corpRemoteMethod(){
              //this.applicantLoading = true;
              let param={
                operator_id:sessionStorage.getItem('user_id'),
                company_id:159,//sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.corpList(param).then(res=>{
                if(res.code == 200){
                  ////console.log('1122',res.data)
                  this.corpList = res.data.data;
                }else{
                  this.$message.error(res.msg);
                }
              }).catch(error=>{
                //console.log(error);
              })
            },
            chooseProductInfo(product_md_name,...params){

                this.addForm.product_md_name=product_md_name;
                this.addForm.product_md_id=params[0];
                this.addForm.corp_name=params[1];
                this.addForm.product_name=params[2];

            },
            chooseCarInfo(plate_number,...params){
                this.addForm.plate_number=plate_number;
                this.addForm.car_id=params[0];
            },
            handleClick(){

            },
            closeProduct(){

            },
            okCar(){
                this.productVisible=false;
            },
            chooseCar(index){
                this.productVisible=true;
                this.carIndex=index;
                ////console.log('list0-------',this.list)
            },
            chsProduct(){
                 this.isShowProduct=true;
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.carList.filter(item => {
                            return item.name.indexOf(query) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            onClose(){
                this.$emit('close')
            },
            close(){
                this.$emit('close')
            },
            handleBeforeUpload(){

            },
            uploadSuccess(){

            },

            handleChange(file,fileList,index){
                let _this=this;

                //------上传到阿里云
                let carFd = new FormData()
                carFd.append('file', file.raw)
                carFd.append('file_type', 1)
                // carFd.append('file_value', this.addForm.vin)
                carFd.append('company_id', sessionStorage.getItem('company_id'))
                carFd.append('access_token', sessionStorage.getItem('token'))
                this.$axios.ossUploadFile(carFd).then(res11 => {

                    //console.log('aliyun--------',res11)
                    if (res11.code == 200) {
                        this.$message.success(res11.msg)
                        _this.list[index].file_url = res11.data.src;
                        //console.log('file_url--------', _this.list[index].file_url)

                    } else if (res11.code == 1) {
                        this.$message.error(res11.msg)
                    }
                }).catch(function (error) {
                    //console.log(error);
                })
                //------上传到阿里云
            },
            save(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var param={
                            company_id:sessionStorage.getItem('company_id'),
                            access_token:sessionStorage.getItem('token'),
                            data:[]
                        };

                        for (var j=0;j<this.list.length;j++){
                            var pm={
                                type:2,
                                shop_id:this.list[j].shop_id,
                                owner_id:this.list[j].shop_id,
                                owner_name:this.list[j].allPerson,
                                owner_idcard:"1",
                                owner_mobile:"1",
                                toubao_name:this.list[j].allPerson,
                                toubao_idcard:"1",
                                toubao_mobile:"1",
                                car_id:this.list[j].car_id,
                                product_id:this.addForm.product_id,
                                product_md_id:this.addForm.product_md_id,

                                pay_id:0,
                                corp_id:this.addForm.corp_id,
                                sell_price:this.addForm.old_sell_price,
                                price:this.addForm.price,
                                real_price:this.addForm.real_price,
                                effective_date:this.list[j].effective_date,
                                end_time:this.list[j].end_time,
                                start_time:this.list[j].start_time,
                                file_url:this.list[j].file_url,
                                shoukuan_type:1,//收款方式
                                account:'',
                                account_number:'',

                                pay_date:'',
                                payee_account:'',
                                pay_remark: "",
                                pay_money: 1,
                                payee_account_number: "",
                                title: "",
                                payee_bank_name: "",
                                account_bank_name: "",
                                big_amount: "",
                                small_amount: "",
                                bank_receipt_sn: "",
                                receipt_sn: "",
                                bank_desc: "",
                                bank_use: "",
                                bank_date: "",
                                remark:'',
                            };
                            param.data.push(pm)
                        }
                        ////console.log('addForm------',param);
                        this.$axios.saveOrderBySysProduct(param).then(res =>{
                            if(res.code == 200){
                                this.$message.success(res.msg)
                                this.$router.push('/insuranceSysTeamOrder')
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            },
            dealSpace(str){
                return str.replace(/&nbsp;/gi, " ");
            },
            //合计 表格每一列需要带上prop
            getSummaries(param) {

                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return Math.round((prev+curr)*100)/100;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '(元)';
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            //新增数据
            addItem() {

                //必须选完险种方案才能添加车辆
                if(this.currIndex<=0){
                  this.$message.error('请先选择险种方案，才能选车')
                  return false
                }
              this.productVisible=true;
            },
            //删除数据
            deleteItem(index, list) {
                if(this.index>0){
                    this.index=this.index-1;
                }
                this.pIndex = -1;
                list.splice(index, 1);
              //console.log('deleteItem-index',index);
              //console.log('deleteItem-pIndex',this.pIndex);
              //console.log('deleteItem-list',list);
              this.carGroups=[];
              let json2= this.arrayGroupBy(list,'allPerson');
              //console.log('deleteItem-arrayGroupBy-----',json2)
              let tmpList2=[];
              let {keys,values,entries} = Object
              for (const [key,val] of entries(json2)) {
                let reg = new RegExp('"',"g");
                let newKey = key.replace(reg, "");
                tmpList2.push({
                  type:newKey,
                  data:val
                })
              }
              //console.log('deleteItem-arrayGroupBy_rs-----',tmpList2)
              if(tmpList2.length>0){
                for (var i=0;i<tmpList2.length;i++){
                  let itm={
                    allPerson:tmpList2[i].type,
                    credit_code:tmpList2[i].data[0].credit_code,
                    num:tmpList2[i].data.length
                  }
                  this.carGroups.push(itm);
                }
              }
              this.productList[index].checked = false

              if(index==0){
                this.carGroups = [];
              }
            },
            //编辑数据
            edit(index, row) {
                this.$set(row, 'isEgdit', true)
            },
            //编辑成功
            editSuccess(index, row) {
                this.$set(row, 'isEgdit', false)
            },
            getProductMList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    page:this.pageNumP,
                    pageSize:this.pageSizeP,
                    type:3 //系统内出单
                }
                if(this.searchForm.keywords) param.queryParams=this.searchForm.keywords;
                if(this.searchForm.corp_id) param.corp_id=this.searchForm.corp_id;
                this.$axios.insuranceProductMdList(param).then(res => {
                    if (res.code == 200) {
                        this.productMList = res.data.data
                        this.totalP = res.data.total
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error => {
                    //console.log(error);
                })
            },
            clickChange(row,index){
                this.ProTitle = '投保告知';
                this.noticeVisible=true;
                this.currIndex=index;
                this.addForm.product_md_name=row.title;
                this.addForm.product_md_id=row.id;
                this.addForm.price=row.price;
                this.addForm.sell_price= row.shopmd[0] ? row.shopmd[0]['sell_price'] :row.sell_price;//row.sell_price; //row.sell_price;
                this.addForm.old_sell_price = row.old_sell_price;
                this.addForm.real_price=row.real_price;
                this.cpys=row.cpys;
            },

            startDateChange(date,idx){
                //console.log('start_time----',date)
                //console.log('idx----',idx)
                this.list[idx].start_time=date;
                let tmp=new Date(date);
                this.list[idx].end_time=this.getNextYearDay(tmp);
            },
            getNextYearDay(date){
                var tmp= moment(date.getFullYear()+"-"+(date.getMonth()+1)+'-'+date.getDate()).add(1, 'y').format('YYYY-MM-DD');
                return  moment(tmp).subtract(1, 'days').format('YYYY-MM-DD 23:59:59');
            },
            getNowTime(y=0,m=0,d=0) {
               return moment().format("yyyy-MM-DD HH:mm:ss")
            },
            getNowDate(y=0,m=0,d=0) {
                var now = new Date();

                var year = now.getFullYear()+y; //得到年份
                var month = now.getMonth(); //得到月份
                var date = now.getDate()+d; //得到日期
                var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1+m;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}`;
                //console.log(defaultDate)
                return defaultDate;

            },
            arrayGroupBy(list, groupId){
                //根据数组属性分组 let json = this.arrayGroupBy(this.list,"type")
                function groupBy(array, f){
                    const groups = {}
                    array.forEach(function (o) {
                        const group = JSON.stringify(f(o))
                        groups[group] = groups[group] || []
                        groups[group].push(o)
                    })
                    return groups;
                }
                return groupBy(list, function (item) {
                    return item[groupId]
                });
            },
        },
        computed: {
            applicantSet() {
                return this.applicantStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}-${item.name}` };
                });
            },
            corpSet() {
                return this.corpStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}` };
                });
            }
        },
    }
</script>
<style lang="less" scoped>
    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .upload_list {
            width: 100px;
            margin-right: 1rem;

        }

        /deep/.el-upload-dragger .el-upload__text {
            font-size: 10px;
            color: #409EFF;
        }

        /deep/.el-icon-upload:before {
            width: 30px !important;
            height: 30px !important;
        }
        .upload_list:last-child {
            margin-right: 0;
        }

        /deep/.el-upload-dragger {
            width: 100%;
            height: auto;
            padding: 20px 0;
            border: 1px solid #999;
        }

        /deep/.el-upload {
            width: 100%;
        }

        /deep/.el-upload-dragger .el-icon-upload {
            margin: 10px 0;
        }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
    /deep/.el-table__body tr.current-row > td {
        background-color:#a4da89 !important;
    }


    /deep/.el-upload-dragger {
        width: 50px !important;
        height: 50px !important;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .avatar {
        width: 50px !important;
        height: 50px !important;
        display: block;
    }
    .sysDl{
      display:flex;
      flex-direction: row;
      align-items: center;
      justify-content:flex-start;
    }
    .sysDl dt,.sysDd{
      border-radius: 5px;width: 30%;
    }
    .sysDl dt{
      background-color: #e1f3d8;
    }
    .sysDl .sysDd{
      background-color: #e6f1fe;
      margin-left: 50px;
      position: relative;
    }
    .sysDl h5{
      color: #666;padding:20px 0 0 20px;
    }
    .sysDl .sysDd .sysP{
      display:flex;flex-direction: row;align-items: center;padding: 10px;
    }
    .sysDl .sysDd .sysdiv{
      display:flex;flex-direction:column;width: 30%;position: absolute; top:30px;left: 65%
    }
    /deep/.el-table__body,/deep/.el-dialog {
      height: auto !important;
    }

</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceSysProduct.vue